import classNames from "classnames";
import { ToolbarButton } from "./Button";
import { ToolbarProvider } from "./Context";
import type { ToolbarContextProps } from "./Context";
import { ToolbarDropdownButton } from "./DropdownButton";
import { ToolbarGroup } from "./Group";
import { ToolbarIconButton } from "./IconButton";
import { ToolbarIndicator } from "./Indicator";
import { ToolbarItem } from "./Item";
import { ToolbarPopover } from "./Popover";
import { ToolbarTooltip } from "./Tooltip";

interface ToolbarProps extends ToolbarContextProps {
  animationDirection?: "up" | "down";
  autoHide?: boolean;
  children: React.ReactNode;
}

const ToolbarComponent = ({
  children,
  autoHide,
  animationDirection = "up",
  theme,
}: ToolbarProps) => (
  <ToolbarProvider theme={theme}>
    <div
      className={classNames(
        "flex items-center justify-between px-6 py-4 transition-transform duration-300 ease-in-out",
        {
          "absolute opacity-0": autoHide,
          "translate-y-full": autoHide && animationDirection === "up",
          "-translate-y-full": autoHide && animationDirection === "down",
          "relative translate-y-0 opacity-100": !autoHide,
        },
      )}
    >
      {children}
    </div>
  </ToolbarProvider>
);

export const Toolbar = Object.assign(ToolbarComponent, {
  Group: ToolbarGroup,
  Button: ToolbarButton,
  IconButton: ToolbarIconButton,
  Item: ToolbarItem,
  Indicator: ToolbarIndicator,
  DropdownButton: ToolbarDropdownButton,
  Popover: ToolbarPopover,
  Tooltip: ToolbarTooltip,
});
